import { Issue } from '@news-mono/web-common'
import React, { RefObject } from 'react'
import { calcRem } from '../../../__styling'
import { ComputedPackageImage } from '../../../user-registration/breach/components/SubscriptionPackage/ComputedPackageImage'
import { InternalMastheadLogo } from '../../TheWestHeader'
import {
    StyledModal,
    StyledModalMain,
    StyledIconCrossSpanWrapper,
    StyledIconCross,
    StyledText,
    StyledSubscribeButton,
    StyledOutlinedButton,
} from './LatestEdition.styled'
import { TheWestSection } from '@news-mono/common'

export interface SubscriberModalProps {
    showModal: boolean
    setShowModal: (showModal: boolean) => void
    handleClickOutsideModal: (e: React.MouseEvent<HTMLDivElement>) => void
    innerModalRef: React.MutableRefObject<null>
    crossIconRef: RefObject<HTMLButtonElement>
    section: TheWestSection
    isLoggedIn: boolean
    onLoginClick: () => void
}

export const SubscriberModal: React.FC<SubscriberModalProps> = ({
    showModal,
    setShowModal,
    handleClickOutsideModal,
    innerModalRef,
    crossIconRef,
    section,
    isLoggedIn,
    onLoginClick,
}) => {
    return (
        <StyledModal showModal={showModal} onClick={handleClickOutsideModal}>
            <StyledModalMain className="modal-main" ref={innerModalRef}>
                <StyledIconCrossSpanWrapper
                    tabIndex={0}
                    ref={crossIconRef}
                    onClick={() => {
                        setShowModal(false)
                    }}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                            setShowModal(false)
                        }
                    }}
                >
                    <StyledIconCross />
                </StyledIconCrossSpanWrapper>
                <div style={{ width: '80%', marginTop: calcRem(40) }}>
                    <InternalMastheadLogo />
                </div>
                <StyledText>Read the paper, as it was printed.</StyledText>
                <ComputedPackageImage
                    section={section}
                    editionsModal={true}
                ></ComputedPackageImage>
                <StyledSubscribeButton
                    onClick={() => {
                        setShowModal(false)
                        window.open('/editions/subscribe')
                    }}
                >
                    Subscribe from{' '}
                    <text style={{ textDecoration: 'underline' }}>
                        $1 per day
                    </text>
                </StyledSubscribeButton>
                {!isLoggedIn && (
                    <StyledOutlinedButton
                        onClick={onLoginClick}
                        onFocus={() => console.log('Button Focused')}
                    >
                        Log in
                    </StyledOutlinedButton>
                )}
            </StyledModalMain>
        </StyledModal>
    )
}
